export enum TransferStatusEnum {
  pendent = 1,
  sent = 2,
  received = 3,
}
